// From https://raw.githubusercontent.com/googlefonts/noto-emoji/main/svg/emoji_u1f34c.svg

import { SVG_SIZE_L } from 'src/constants';

export const GoogleNanoBananaLogo = ({
  size = SVG_SIZE_L,
}: {
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#FF8E00"
        d="M119.22,95.12c-1.14,2.36-5.91,2.21-8.54,1.38c-6.72-2.12-10.9-7.9-10.9-7.9L65.14,73.9l-10.61-5.57
	c0,0-2.06-3.5,2.06-6.17s7.01-2.87,7.01-2.87l11.94,7.6c0,0,7.71-6,15.54-6.91c7.48-0.86,16.79,5.22,19.24,16.7
	c1.99,9.31,5.14,12.59,6.09,13.8C117.36,91.7,120.2,93.1,119.22,95.12z"
      />
      <path
        fill="#FFE4B4"
        d="M77.72,32.15C74.65,21.99,70.77,10.1,64.91,6.03c-5.19-3.6-10.24-2.95-12.64-1.38
	c0,0-4.33,1.77-5.47,6.24c-1.88,7.34,0.59,16.15,2.2,25.25c1.61,9.1,2.45,15.36,3.18,22.67c0.07,0.66,12.16,22.18,12.16,22.18
	l9.65,5.17c0,0,7.37-15.94,7.26-18.19C81.15,65.71,79.96,39.57,77.72,32.15z"
      />
      <path
        fill="#FFE265"
        d="M52.55,66.94c-0.13,2.43,5.73,21.8,5.73,21.8l15.72-2.6c0,0,11.15-6.6,11.46-18.57
	c0.48-18.05-2.61-26.55-4.85-33.97C77.53,23.46,70.67,10.1,64.86,5.96c-3.41-2.43-7.19-2.79-8.74-2.49c0,0,10.32,8.08,15.54,21.9
	s6.45,29.79,6.45,29.79s-3.84,2.83-12.9,4.13c-7,1.01-13.04-0.7-13.04-0.7S52.72,63.86,52.55,66.94z"
      />
      <path
        fill="#FFA726"
        d="M85.33,83.75l-6.29-13.14l0.34-4.68c0,0,1.34-3.93-7.03,2.42c-3.88,2.94-6.22,8.36-6.22,8.36
	s-1.18-2.92-5.32-6.78c-3.68-3.42-8.63-5.08-8.63-5.08s-10.28-2-11.4-1.13c-7.25,5.66-12.55,12.55-12.55,12.55L22.9,96.42
	l-8.86,5.43c0,0,2.42,3.54,5.92,2.22c2.73-1.03,6.11-4.12,7.93-8.01c2.50-5.35,7.75-15.47,10.42-18.67
	c5.16-6.16,10.22-8.41,13.99-6.62c4.29,2.03,0.86,22.29,0.86,22.29l-27.58,23.21l-0.47,3.16c0,0,4.01,3.85,15.06,3.49
	s25.83-4.45,35.18-17.2C83.60,94.48,85.33,83.75,85.33,83.75z"
      />
      <path
        fill="#FFB803"
        d="M63.58,84.96c0.24,5.55-3.22,13.96-11.22,20.97c-7.99,7.01-16.43,9.33-21.67,9.73
	c-3.80,0.29-4.93-1.88-4.93-1.88s7.66-7.05,13.35-12.7c5.40-5.37,11.28-16.65,12.56-21.84c1.28-5.19,0.12-8.68,0.12-8.68
	s2.48,0.69,6.13,4.35C61.46,78.46,63.45,81.88,63.58,84.96z"
      />
      <path
        fill="#875B54"
        d="M29.45,118.74c-0.83,1.93-3.68,2.01-4.92,0.94c-1.17-1.01-2.31-3.02-1.13-5.27
	c0.78-1.48,3.34-1.89,4.78-0.74S30.20,116.99,29.45,118.74z"
      />
      <path
        fill="#FEE4B4"
        d="M23.76,97.84c-3.28,4.55-6.57,5.24-7.93,5.39c-1.19,0.14-2.49-1.38-2.34-2.78
	c0.15-1.40,2.45-3.37,2.73-7.67c0.28-4.30-0.06-20.07,8.69-29.13c6.17-6.38,13.73-4.18,18.61-2.49c5.50,1.90,8.67,3.70,8.67,3.70
	s-4.50-0.31-12.26,5.81c-4.51,3.56-7.16,8.45-9.66,14.06C28.47,88.79,26.07,94.64,23.76,97.84z"
      />
      <path
        fill="#FEB804"
        d="M111,109.58c-0.92,1.84-3.17,2.98-5.16,2.89c-4.21-0.18-8.05-2.35-12.30-7.83
	C87.53,96.88,82.30,78.26,78.38,73.30c-2.65-3.35-5.95-5.01-5.95-5.01s1.82-1.54,3.64-2.49c1.82-0.95,6.22-0.50,6.22-0.50l18.78,30.18
	L111,109.58z"
      />
      <path
        fill="#FFE4B4"
        d="M100.39,68.46c4.12,5.89,4.66,11.06,5.28,16.34c0.56,4.77,1.71,14.80,3.44,18.07
	c1.74,3.27,3.43,5.40,1.56,7.39s-7.37,1.28-11.32-3.02c-3.18-3.47-4.94-7.25-7.33-12.80c-2.39-5.55-5.91-18.65-10.48-24.57
	c-2.92-3.78-5.83-3.89-5.83-3.89s3.85-3.14,11.20-3.22C93.50,62.69,96.96,63.56,100.39,68.46z"
      />
    </svg>
  );
};
